import { render } from "./LookbookIndex.vue?vue&type=template&id=7220dd6f"
import script from "./LookbookIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./LookbookIndex.vue?vue&type=script&setup=true&lang=js"

import "./LookbookIndex.vue?vue&type=style&index=0&id=7220dd6f&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Sales/Lookbook/LookbookIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7220dd6f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7220dd6f', __exports__)) {
    api.reload('7220dd6f', __exports__)
  }
  
  module.hot.accept("./LookbookIndex.vue?vue&type=template&id=7220dd6f", () => {
    api.rerender('7220dd6f', render)
  })

}


export default __exports__